import { useState } from 'react';
import styled from 'styled-components';

import { Carousel } from 'atoms/navigation/Carousel';
import { tabletAndAbove } from 'style/mediaQuery';

interface Img {
  src: string;
  alt: string;
}

const CarouselContainer = styled.div`
  margin: auto;
`;

const Img = styled.img`
  aspect-ratio: var(--card-aspect-ratio);
  max-width: 200px;
  @media ${tabletAndAbove} {
    max-width: 200px;
  }
`;

const ImgContainer = styled.div`
  position: relative;
  &:after {
    content: '';
    width: 100%;
    left: 0;
    position: absolute;
    top: 100%;
    box-shadow: 0px 0px 27px 4px rgba(0, 0, 0, 0.67);
  }
`;

type Props = {
  cards: Img[];
  defaultActiveCard?: number;
};

export const CardsCarousel = ({ cards, defaultActiveCard }: Props) => {
  const [index, setIndex] = useState(
    defaultActiveCard || Math.floor(cards.length / 2)
  );

  return (
    <CarouselContainer>
      <Carousel
        elements={cards}
        renderElement={card => {
          return (
            <ImgContainer key={card.alt}>
              <Img loading="lazy" src={card.src} alt={card.alt} />
            </ImgContainer>
          );
        }}
        selectedIndex={index}
        setSelectedIndex={setIndex}
        onClick={(_, i) => setIndex(i)}
      />
    </CarouselContainer>
  );
};
